export default "__VITE_ASSET__0820ea69__"